/* eslint-disable security/detect-unsafe-regex */

export const REGEXES_DICTIONARY = {
  phoneRegex: /^(?:|[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6})$/gm,
  urlRegex: /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*\\+,;=.]+$/gm,
};
